import { hydrate } from 'react-dom';
import { Globals } from '@bwoty-web/ui-kit';
import FootballFixtures from '../shared/views/footballView/footballFixtures';

const initialState = window.INITIAL_STATE_FOOTBALL_FIXTURES;

// Sets webpack publicPath for files during runtime, since the publicPath is different for each environment.
// webmastercomponents-acctest.nltg.com for PrePrd and //webmastercomponents.nltg.com for Prd etc.
// Filepaths cannot be relative since the script is run on other domains.
// eslint-disable-next-line camelcase, no-undef
__webpack_public_path__ = `${initialState?.siteSettings?.baseUrl}/static/`;

// delete window.INITIAL_STATE_INITIAL_STATE_FOOTBALL_FIXTURES;
const footballFixtures = document.getElementById('football-fixtures-root');

if (footballFixtures) {
  hydrate(
    <Globals siteId={initialState.siteSettings.siteId} labels={initialState.attributeCollection}>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <FootballFixtures {...initialState} />
    </Globals>,
    footballFixtures,
  );
}
